module.exports = __webpack_public_path__ + "img/h-page4-53.3d72a244.png";